import { settingContent } from '@/api/setting'
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import help from '@/utils/help'
import { getUploadConfig } from '@/utils/upload'

const columns = [
  {
    title: '',
    enTitle: 'File Name',
    width: 150,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Link',
    width: 150,
    dataIndex: 'path',
    slot: 'path'
  },
  {
    title: '',
    enTitle: 'Operated Time',
    width: 120,
    sort: true,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 80,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]

export default {
  components: {
    SiteSearchGroup
  },
  data() {
    return {
      columns,
      params: {
        keyword: '',
        sorted: ''
      },

      dataSource: [],
      inputData: {},
      showAdv: true,
      isVisable: false,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      loading: false,
      fileList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      country: 'getCountry',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const { list, pageIndex, pageSize, total } = await settingContent.get(
        data
      )
      this.dataSource = list

      this.fileList = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    detail(val) {
      this.inputData = val
      this.isVisable = true
    },
    cancel() {
      this.isVisable = false
    },
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }
    },
    async addFile(file) {
      this.loading = true
      const flag = this.fileList.some(val => {
        if (file.name === val.name) {
          return true
        }
      })
      if (flag) {
        this.loading = false
        this.$message.error({
          title: 'Error',
          content: 'The file already exists. Please update the file.'
        })
      } else if (!flag) {
        const path = 'files'
        const url = await getUploadConfig(file, path, file.name)
        if (url.includes('err:')) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].uploadFileFail
          })
          return false
        }
        const params = {
          name: file.name,
          size: file.size,
          path: url,
          file: file,
          sort: ''
        }
        await settingContent.add(params)
        this.$message.success({
          title: 'Success',
          content: 'File Uploaded Successfully'
        })
        this.loading = false
        this.getList()
        this.fileList.forEach((item, index) => {
          item.sort = index
        })
      }
    },

    // 下载
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    // 删除
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await settingContent.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
        this.getList()
      })
    },
    // Copy File Address
    handleCopyAddress(val) {
      this.urlAddress = this.domain + '/' + val
      help.copyToBlock(this.urlAddress)
      this.$message.success({
        title: 'Success',
        content: 'The File Address has been copied to the clipboard!'
      })
    },
    handleClear() {
      this.params = {}
      this.getList()
    },

    async handleUpdate(current, files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        const currentType = current.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!currentType.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile1(current, file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile1(current, file)
          }
        })
      }
    },
    async addFile1(current, file) {
      const path = 'files'
      const url = await getUploadConfig(file, path, current.name)
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      const params = {
        name: current.name,
        size: file.size,
        path: url,
        file: file,
        sort: ''
      }
      await settingContent.edit(current.id, params)
      this.$message.success({
        title: 'Success',
        content: 'File Uploaded Successfully'
      })
      this.getList()
      this.fileList.forEach((item, index) => {
        item.sort = index
      })
    }
  }
}
